module.exports = __webpack_public_path__ + "img/airpay-icons.f908de86.svg";